import React from "react";
import { StyleSheet, TouchableOpacity } from "react-native";
import { useLinkTo } from "@react-navigation/native";
import { Text, View } from "./Themed";
import Config from "../constants/Config";
import i18n from "../utils/localization";

export default function PublicFooter() {
  const linkTo = useLinkTo();
  const legal = Config.legal || {};

  return (
    <View style={styles.footer}>
      <Text style={styles.companyLine}>
        {legal.companyName} · {legal.taxIdLabel} {legal.taxId} · {legal.address}
      </Text>
      <View style={styles.linkRow}>
        <TouchableOpacity onPress={() => linkTo("/terms")}>
          <Text style={styles.link}>{i18n.t("Terms & conditions")}</Text>
        </TouchableOpacity>
        <Text style={styles.separator}>·</Text>
        <TouchableOpacity onPress={() => linkTo("/refund-policy")}>
          <Text style={styles.link}>{i18n.t("Refund / return / cancellation policy")}</Text>
        </TouchableOpacity>
        <Text style={styles.separator}>·</Text>
        <TouchableOpacity onPress={() => linkTo("/delivery-terms")}>
          <Text style={styles.link}>{i18n.t("Delivery terms")}</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  footer: {
    paddingHorizontal: 16,
    paddingVertical: 18,
    gap: 8,
    borderTopWidth: 1,
    borderTopColor: "#e2e8f0",
    alignItems: "center",
  },
  companyLine: {
    color: "#64748b",
    fontSize: 12,
    textAlign: "center",
  },
  linkRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    gap: 8,
  },
  link: {
    color: "#2563eb",
    fontSize: 12,
    fontWeight: "600",
  },
  separator: {
    color: "#cbd5e1",
    fontSize: 12,
  },
});
